var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-symbol-container"},[_c('div',{staticClass:"loading-symbol",style:({'background-image': 'url(./static/loading_wave.svg'})})])}
var staticRenderFns = []

export { render, staticRenderFns }